import { ClientAssignmentNestedObjectsResponse } from '../../../../web-api-client';
import { UserEngagementAssignment } from '../../models';

/**
 * Maps a client assignment response to a user engagement assignment.
 * @param response The client assignment response to be mapped.
 * @returns The mapped user engagement assignment.
 */
export const mapUserEngagementAssignmentFromResponse = (
  response: ClientAssignmentNestedObjectsResponse
): UserEngagementAssignment => ({
  clientId: response.clientId ?? 0,
  clientName: '',
  isActive: response.isActive ?? false,
});
